import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { of, Observable, Subscription } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { League } from '../models/league';
import { LeagueStorage } from '../models/league.storage';
import { UUID } from '../models/uuid';

import { GenericService } from './generic.service';
import { PageableService } from './pageable.service';
import { GetPagedResponse } from './responses/generic.responses';
import { GetDealerTournamentDetailsResponse } from './responses/tournament.responses';

@Injectable()
export class DealerTournamentService extends GenericService implements PageableService {
  league: League;
  _propertySubscription: Subscription;
  constructor(
    private http: HttpClient,
    private leagueStorage: LeagueStorage,
    protected logger: NGXLogger
  ) {
    super(logger);
    this._propertySubscription = leagueStorage.getSelectedLeague().subscribe(league => {
      this.league = league;
    });
  }

  public getPagedData(params: any): Observable<GetPagedResponse> {
    if (params.dealer_id) {
      const dealerId = params.dealer_id;
      delete params.dealer_id;
      return this.getDealerTournaments(dealerId, params).pipe(
        map(r => {
          return {
            data: r.dealer_tournament_details,
            pagination: r.pagination
          };
        })
      );
    } else {
      return of(this.defaultResponse('dealer_tournament_details'));
    }
  }

  public getDealerTournaments(
    dealerId: UUID,
    params: any
  ): Observable<GetDealerTournamentDetailsResponse | any> {
    this.logger.debug('Called getDealerTournaments');
    if (this.league == null) {
      this.logger.debug('returning default tournaments');
      return of(this.defaultResponse('dealer_tournament_details'));
    }
    this.logger.debug('calling get dealer tournaments service');
    const options = {
      headers: this.httpOptions.headers,
      params: new HttpParams({ fromObject: params })
    };

    return this.http
      .get<GetDealerTournamentDetailsResponse>(
        `${environment.TOURNAMENTS_API}/league/${this.league.id}/dealer/${dealerId}/tournament`,
        options
      )
      .pipe(tap(response => this.logger.debug('getDealerTournaments response:', response)))
      .pipe(catchError(this.handleError.bind(this)));
  }
}
